import { useState } from 'react';
import { API_URL } from '@constants';
import { ApiError, useApiConfig } from '@hooks/useApiConfig';

const ENDPOINT_URL = '/cfg-system-settings/banner_ready_to_boost';

export interface BannerReadyToBoost {
    content_banner_ready_to_boost_subtitle: string | null;
    content_banner_ready_to_boost_title: string | null;
    content_banner_ready_to_boost_description: string | null;
    content_banner_ready_to_boost_button_text: string | null;
    content_banner_ready_to_boost_link: string | null;
    content_banner_ready_to_boost_image: string | null;
}

export interface GetBannerReadyToBoostSuccessResponse {
    data: BannerReadyToBoost;
    success: boolean;
    message: string;
}

export const useGetBannerReadyToBoost = () => {
    const { getHeaders, getCommonParameters, handleCommonErrors } = useApiConfig();
    const [banner, setBanner] = useState<BannerReadyToBoost | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    const request = async () => {
        setLoading(true);
        setError(null);

        try {
            const inputParameters = new URLSearchParams(getCommonParameters()).toString();

            const response = await fetch(`${API_URL}${ENDPOINT_URL}?${inputParameters}`, {
                method: 'GET',
                headers: getHeaders(),
            });

            if (!response.ok) {
                const json = await response.json();
                const error = new Error(json.error || json.message || 'Erro ao buscar banner ready to boost') as ApiError;
                error.statusCode = response.status;
                throw error;
            }

            const result: GetBannerReadyToBoostSuccessResponse = await response.json();

            setBanner(result.data);
        } catch (err: any) {
            handleCommonErrors(err);
            setError(err.message || 'Erro ao buscar banner ready to boost');
        } finally {
            setLoading(false);
        }
    };

    return { banner, request, loading, error };
};
